<template>
  <div :id="'chart_'+uuid">
    <div class="chart-container" style="position: relative;" :style="`width: ${size.width}; height: ${size.height};`">
      <canvas :id="uuid" :width="size.width" :height="size.height" />
    </div>
  </div>
</template>

<script>
import { Chart } from "chart.js/auto";

export default {
  name: "1229589b-7d96-11eb-811b-00155d01060e",
  props: ['chart', 'size', 'title', 'uuid'],
  mounted() {
    this.canvas = document.getElementById(this.uuid).getContext('2d')
    this.make_chart()
  },
  data() {
    return {
      canvas: null,
      graph: null,
      periods: [],
      registrated: [],
      closed: [],
      notclosed: []
    }
  },
  computed: {
    report_data() {
      return this.chart.report_data
    }
  },
  watch: {
    report_data() {
      this.update_chart()
    }
  },
  methods: {
    make_chart: function () {
      if (this.canvas) {
        this.update_data()
        this.graph = new Chart(this.canvas, {
          type: 'line',
          data: {
            labels: this.periods,
            datasets: [
              {
                label: 'Количество зарегистрированных',
                data: this.registrated,
                pointStyle: 'circle',
                pointRadius: 0
              },
              {
                label: 'Количество восстановленных',
                data: this.closed,
                pointStyle: 'rect',
                pointRadius: 0
              },
              {
                label: 'Количество невосстановленных',
                data: this.notclosed,
                pointStyle: 'triangle',
                pointRadius: 0
              }
            ]
          },
          options: {
            scales: {
              y: {
                beginAtZero: true,
                title: {
                  display: true,
                  text: 'Кол-во обращений'
                }
              }
            },
            plugins: {
              datalabels: {
                display: false
              }
            }
          }
        })
      }
    },
    update_data: function () {
      this.periods = []
      this.registrated = []
      this.closed = []
      this.notclosed = []

      for (let i = 0; i < this.chart.report_data.length; i++) {
        if (!this.periods.includes(this.chart.report_data[i]["Период"])) { this.periods.push(this.chart.report_data[i]["Период"]) }
        this.registrated.push(this.chart.report_data[i]["КоличествоЗарегистрированных"])
      }

      for (let i = 0; i < this.periods.length; i++) {
        this.closed.push(this.chart.report_data[i+this.periods.length]["КоличествоЗакрытых"])
      }

      for (let i = 0; i < this.periods.length; i++) {
        let date = new Date(Date.parse(this.periods[i]))
        let options = {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        }
        this.periods[i] = date.toLocaleString("ru-RU", options)
      }

      for (let i = 0; i < this.periods.length; i++) {
        this.notclosed.push(this.registrated[i] - this.closed[i])
      }
    },
    update_chart: function () {
      this.update_data()
      this.graph.destroy()
      this.make_chart()
    }
  }
}
</script>